import React, { useEffect } from "react"

export function HistoryOrders() {
  return <p>历史订单面板</p>
}
